import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  GetCurationServiceRequest,
  GetCurationsMeServiceRequest,
  GetCurationsOrderListServiceRequest,
  GetCurationsServiceRequest,
  GetCurationTabsVisibilityServiceRequest,
} from '@musinsa/services-curator';
import {
  checkCurationCreatableService,
  getCurationService,
  getCurationSnapsService,
  getCurationsMeService,
  getCurationsOrderListService,
  getCurationsService,
  getCurationTabsVisibilityService,
  getMySnapsService,
} from '@musinsa/services-curator';

export const curationsFactory = createQueryKeys('curations', {
  myList: (params: Omit<GetCurationsMeServiceRequest, 'page'>) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCurationsMeService({ ...params, page: pageParam }),
  }),
  list: (params: Omit<GetCurationsServiceRequest, 'page'>) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCurationsService({ ...params, page: pageParam }),
  }),
  detail: (params: GetCurationServiceRequest) => ({
    queryKey: [params.curationId, params],
    queryFn: () => getCurationService(params),
  }),
  orderList: (params?: GetCurationsOrderListServiceRequest) => ({
    queryKey: [{ params }],
    queryFn: () => getCurationsOrderListService(params),
  }),
  checkCurationCreatable: () => ({
    queryKey: ['check-curation-creatable'],
    queryFn: () => checkCurationCreatableService(),
  }),
  curationTabsVisibility: (params: GetCurationTabsVisibilityServiceRequest) => ({
    queryKey: [params.snsTitle],
    queryFn: () => getCurationTabsVisibilityService(params),
  }),
  snapDetail: (params: { curationId: string; snapId?: string; size: number }) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCurationSnapsService({
        curationId: params.curationId,
        page: pageParam,
        size: params.size,
        ...(pageParam === 1 && params.snapId !== undefined ? { snapId: params.snapId } : {}),
      }),
  }),
  /** 큐레이션 생성 시 — `GET /v2/curations/snaps` (page/size 쿼리, 플랫폼은 `x-platform` 헤더) */
  mySnaps: (params: { size: number }) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getMySnapsService({ page: pageParam, size: params.size }),
  }),
  mySnapsPage: (params: { page: number; size: number }) => ({
    queryKey: [{ scope: 'mySnapsPage' as const, params }],
    queryFn: () => getMySnapsService(params),
  }),
});
